import { render, staticRenderFns } from "./SurveyStats.vue?vue&type=template&id=7040d51a&scoped=true&"
import script from "./SurveyStats.vue?vue&type=script&lang=js&"
export * from "./SurveyStats.vue?vue&type=script&lang=js&"
import style0 from "./SurveyStats.vue?vue&type=style&index=0&id=7040d51a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7040d51a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7040d51a')) {
      api.createRecord('7040d51a', component.options)
    } else {
      api.reload('7040d51a', component.options)
    }
    module.hot.accept("./SurveyStats.vue?vue&type=template&id=7040d51a&scoped=true&", function () {
      api.rerender('7040d51a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/SurveyStats.vue"
export default component.exports